import { CampaignPostDetailsPartial } from "../../partials/menu/campaign/campaign-post-details.partial";

export default function CampaignPostDetailsScreen() {
  return <CampaignPostDetailsPartial />;
}
